<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <!-- Connection Status Bar -->
    <div v-if="showConnectionStatus" class="fixed top-0 left-0 right-0 z-50 p-2 text-center text-sm font-medium">
      <div v-if="isOnline" class="status-online">
        <span class="inline-block w-2 h-2 bg-white rounded-full mr-2"></span>
        Online
      </div>
      <div v-else class="status-offline">
        <span class="inline-block w-2 h-2 bg-white rounded-full mr-2"></span>
        Offline - Leads will sync when connection restored
      </div>
    </div>
    
    <!-- Main Content -->
    <main class="pt-12">
      <router-view />
    </main>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'

// Reactive data
const isOnline = ref(navigator.onLine)
const showConnectionStatus = ref(false)

// Get current route
const route = useRoute()

// Watch for online/offline events
const handleOnline = () => {
  isOnline.value = true
  showConnectionStatus.value = true
  setTimeout(() => {
    showConnectionStatus.value = false
  }, 3000)
}

const handleOffline = () => {
  isOnline.value = false
  showConnectionStatus.value = true
}

// Lifecycle hooks
onMounted(() => {
  // Show connection status on lead capture pages
  if (route.name === 'LeadCapture') {
    showConnectionStatus.value = true
  }
  
  // Add event listeners
  window.addEventListener('online', handleOnline)
  window.addEventListener('offline', handleOffline)
})

onUnmounted(() => {
  // Remove event listeners
  window.removeEventListener('online', handleOnline)
  window.removeEventListener('offline', handleOffline)
})
</script>

<style>
/* Global styles */
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* Prevent zoom on input focus (iOS) */
input, select, textarea {
  font-size: 16px;
}
</style> 